/**
 * Abstract model for a RuleTemplateWidget model. Subclasses are used
 * to discriminate the kind of rule template we are dealing with.
 *
 * RuleTemplate is the source of truth when it comes to the ruleModel!
 *
 * @abstract
 * @param {RuleTemplate} ruleTemplate - Rule template to render
 */
export default class AbstractRuleTemplateModel {
	constructor({ ruleTemplate }) {
		this._form = undefined;
		this.setRuleTemplate(ruleTemplate);
	}

	getRuleTemplate() {
		return this._ruleTemplate;
	}

	isBeta() {
		return this._ruleTemplate.isBeta();
	}

	setRuleTemplate(ruleTemplate) {
		this._ruleTemplate = ruleTemplate;
		this._initialRuleModelData = this._getSerializedRuleModel();
	}

	getRuleModel() {
		return this._ruleTemplate.getRuleModel();
	}

	getLabel() {
		return this.getRuleModel().getLabel();
	}

	getDescription() {
		return this.getRuleModel().getDescription();
	}

	hasDescription() {
		return this.getDescription() !== "";
	}

	setRuleModel(ruleModel) {
		return this._ruleTemplate.setRuleModel(ruleModel);
	}

	getForm() {
		return this._form;
	}

	setForm(form) {
		this._form = form;
	}

	isOwnRule() {
		return false;
	}

	isInheritedRule() {
		return false;
	}

	isNoRule() {
		return false;
	}

	ruleTemplateWidgetContentRenderer(_ruleTemplateWidget) {
		throw new Error("Subclass responsibility");
	}

	ruleTemplateDescriptionWidgetRenderer(_ruleTemplateWidget) {
		return () => {};
	}

	makeSaveActionOn(ruleTemplatesWidget) {
		if (!this._hasRuleModelChanged()) {
			return ruleTemplatesWidget.makeNullRuleTemplateAction(
				this._ruleTemplate,
			);
		}

		return this._makeSaveActionOn(ruleTemplatesWidget);
	}

	makeDeleteActionOn(ruleTemplatesWidget) {
		return this._makeDeleteActionOn(ruleTemplatesWidget);
	}

	_makeSaveActionOn(_ruleTemplatesWidget) {
		throw new Error("Subclass responsibility");
	}

	_makeDeleteActionOn(_ruleTemplatesWidget) {
		throw new Error("Subclass responsibility");
	}

	_hasRuleModelChanged() {
		const currentSerialization = this._getSerializedRuleModel();
		return (
			JSON.stringify(this._initialRuleModelData) !==
			JSON.stringify(currentSerialization)
		);
	}

	_getSerializedRuleModel() {
		return this.getRuleModel()?.serialize();
	}
}
